import {XauditModel} from '../../../models/xaudit.model';
import {ReportParameterModel} from './ReportParameterModel.model';

export class ReportModel extends XauditModel{
  ReportID: string;
  ReportName: string;
  ReportOrderInCategory: number;
  enumReportCategoryID: string;
  Description: string;
  isPatientSpecific: boolean;
  ServerReportName: string;
  cfgReportParameters: ReportParameterModel[];
  enumReportClassID: string;
  enumReportTypeID: string;
  LetterSubstituteID: string;
  LetterTemplateID: string;
  isLetterTemplate: boolean;
}
